import React, { Component } from "react";
import styled from "styled-components";
import { withRouter, Prompt } from "react-router-dom";
import { connect } from "react-redux";

import BlockLoader from "../components/BlockLoader";
import { SiteTemplate } from "../components/Site";

import { Field, reduxForm } from "redux-form";
import {
  renderInputWithLabel,
  renderSelectWithLabel,
  renderDatePickerWithLabel,
  renderWysiwygWithLabel
} from "../components/Form";
import { FullWidthButton } from "../components/Form";

import { Row, Col } from "reactstrap";
import moment from "moment";
import { toast } from "react-toastify";

import routes from "../routes";

import { required } from "../lib/validation";
import { maxLength } from "../lib/normalization";

import { createOffer, updateOffer, get } from "../offers/actions";

const maxLength90 = maxLength(90);
const maxLength200 = maxLength(200);

class Form extends Component {
  componentDidMount = async () => {
    const { edit, match, get, history } = this.props;

    if (edit) {
      const uid = match.params.uid;
      try {
        await get(uid);
      } catch ({ response }) {
        if (response.status === 404) {
          history.replace("/404");
        }
      }
    }
  };

  submit = values => {
    const {
      createOffer,
      updateOffer,
      history,
      match,
      edit,
      get,
      reset
    } = this.props;

    if (edit) {
      const uid = match.params.uid;
      return updateOffer(values, uid).then(() => {
        toast.success("Oferta została zaktualizowana!");
        get(uid);
      });
    } else {
      return createOffer(values).then(({ data }) => {
        toast.success("Oferta została dodana!");
        reset();
        history.push(routes.offers);
      });
    }
  };

  render() {
    const {
      handleSubmit,
      submitting,
      dirty,
      error,
      match,
      offers,
      edit
    } = this.props;

    const uid = match.params.uid;

    return (
      <SiteTemplate title={edit ? "Aktualizuj ofertę" : "Dodaj ofertę"}>
        <Prompt when={dirty} message="" />
        <BlockLoader isLoading={edit && !offers.get(uid)}>
          <StyledForm onSubmit={handleSubmit(this.submit)}>
            <StyledRow>
              <Col xs="6">
                <Field
                  name="title"
                  component={renderInputWithLabel}
                  label="Tytuł"
                  type="text"
                  placeholder="Tytuł"
                  autoFocus
                  validate={[required]}
                  normalize={maxLength90}
                />
                <Field
                  name="startDate"
                  dateFormat="DD/MM/YYYY"
                  minDate={moment()}
                  readOnly
                  component={renderDatePickerWithLabel}
                  label="Data rozpoczęcia pracy"
                  placeholder="Data rozpoczęcia wyjazdu"
                />
                <Field
                  name="shortDesc"
                  component={renderInputWithLabel}
                  label="Krótki opis"
                  type="textarea"
                  placeholder="Krótki opis"
                  normalize={maxLength200}
                />
              </Col>
              <Col xs="6">
                <Field
                  name="country"
                  component={renderInputWithLabel}
                  label="Kraj"
                  type="text"
                  placeholder="Kraj"
                  validate={[required]}
                />
                <Field
                  name="city"
                  component={renderInputWithLabel}
                  label="Miasto"
                  type="text"
                  placeholder="Miasto"
                  validate={[required]}
                />
                <Field
                  name="code"
                  component={renderInputWithLabel}
                  label="Kod pocztowy"
                  type="text"
                  placeholder="Kod pocztowy"
                  validate={[required]}
                />
                <Field
                  name="sex"
                  component={renderSelectWithLabel}
                  label="Płeć"
                  validate={[required]}
                >
                  <option>mężczyzna</option>
                  <option>kobieta</option>
                  <option>inne</option>
                </Field>
              </Col>
            </StyledRow>
            <StyledRow>
              <Col xs="12">
                <Field
                  name="mainDesc"
                  component={renderWysiwygWithLabel}
                  label="Opis oferty"
                  type="textarea"
                  placeholder="Opis oferty"
                />
              </Col>
            </StyledRow>
            <Row>
              <Col xs="12">
                {error && <Error>{error}</Error>}

                <FullWidthButton
                  block
                  loading={submitting}
                  color={dirty ? "warning" : "primary"}
                  type="submit"
                >
                  {edit ? "Aktualizuj" : "Dodaj"}
                </FullWidthButton>
              </Col>
            </Row>
          </StyledForm>
        </BlockLoader>
      </SiteTemplate>
    );
  }
}

const StyledForm = styled.form``;

const StyledRow = styled(Row)`padding: 20px 20px 0px;`;

const Error = styled.div.attrs({ className: "text-danger" })`
  width: 100%;
  font-size: 12px;
  margin-bottom: 20px;
`;

Form = reduxForm({
  form: "offersAddForm",
  destroyOnUnmount: false,
  enableReinitialize: true,

  initialValues: {
    startDate: moment().add(7, "days"),
    sex: "mężczyzna"
  }
})(Form);

Form = connect(
  (state, ownProps) => {
    let { match, edit, initialValues } = ownProps;

    const uid = match.params.uid;
    const offers = state.entities.get("offers");

    const obj = offers.get(uid);

    if (edit && obj) {
      const data = obj.toJS();
      data.startDate = moment(data.startDate);
      initialValues = data;
    }

    return { offers, initialValues };
  },
  {
    createOffer,
    updateOffer,
    get
  }
)(Form);

Form = withRouter(Form);

export default Form;



// WEBPACK FOOTER //
// ./src/offers/Form.js